module.exports = __webpack_public_path__ + "static/img/alldevicetype.81ada061.png";